var initGlobal = function() {
	var initTime = performance.now();
	// Start

	$('.selectPicker').selectpicker();

	
	/* Initiazlie Lazy Loading*/

	var bLazy = new Blazy({ 
	    /*options*/
	});


	// **********************************************************************************************************
	// Header events ********************************************************************************************
	// **********************************************************************************************************

	/*
	$('header').on('click tap', '.searchToggle', function(event) {
		event.preventDefault();
		log('Framework •• Header - Search Togggle - Click Event');
		$('header .flip-container').toggleClass('is-active');
		$('.mobileSearchBar').toggleClass('is-active');
		
		$('header .langSelector').removeClass('is-active');
		$('body').removeClass('nav-is-active');
		$('.burgerToggle').removeClass('is-active');

		if( $(window).width() >= 956 ) {
			$("#searchInput").focus();
		} else {
			$("#mobileSearchInput").focus();
		}
	})

	$('header').on('click tap', '.langToggle', function(event) {
		event.preventDefault();
		log('Framework •• Header - Lang Togggle - Click Event');
		$('header .langSelector').toggleClass('is-active');

		$('body').removeClass('nav-is-active');
		$('.burgerToggle').removeClass('is-active');
		$('.mobileSearchBar').removeClass('is-active');
	})

	$('header').on('click tap', '.burgerToggleHousing', function(event) {
		event.preventDefault();
		log('Framework •• Header - burger Togggle - Click Event');
		$('.burgerToggle').toggleClass('is-active');
		$('header .mobileNav').toggleClass('is-active');
		$('body').toggleClass('nav-is-active');

		$('.mobileSearchBar').removeClass('is-active');
		$('header .langSelector').removeClass('is-active');
	})

	*/

	// ************************************************************************************************************
	// Easter egg - If you remove this code you will break an entire chain of events ******************************
	// ************************************************************************************************************

	// This looks for the tony variable on Blog and Category pages and adds a class to make the header dark
	if (typeof(tony) !== 'undefined') {
		if ( tony ) {
			$('body').addClass('header-dark');
		}
	}

	// End
	// log(config.application.name + " •• global.js in " + Math.ceil( performance.now() - initTime) + " milliseconds" );
}